angular.module('zc.masterApi')
  .factory('MasterMongoLogisticRegressionCoefficients', MasterMongoLogisticRegressionCoefficients);

MasterMongoLogisticRegressionCoefficients.$inject = ['FacadeV2'];
function MasterMongoLogisticRegressionCoefficients(FacadeV2) {
  return { find };

  function find(params) {
    return FacadeV2.request(
      '/master/logistic_regression_coefficients',
      {params}
    )
      .then(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_mongo_logistic_regression_coefficients.service.js